import React, { useState } from 'react';
import { CustomerList } from '../components/customers/CustomerList';
import { CustomerForm } from '../components/customers/CustomerForm';
import { CustomerStats } from '../components/customers/CustomerStats';
import type { Customer } from '../types/customer';

type ViewMode = 'list' | 'create' | 'edit';

export const Customers: React.FC = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | undefined>();

  const handleCreateCustomer = () => {
    setSelectedCustomer(undefined);
    setViewMode('create');
  };

  const handleEditCustomer = (customer: Customer) => {
    setSelectedCustomer(customer);
    setViewMode('edit');
  };

  const handleFormSuccess = () => {
    setViewMode('list');
    setSelectedCustomer(undefined);
  };

  const handleFormCancel = () => {
    setViewMode('list');
    setSelectedCustomer(undefined);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Page Header */}
      <div style={{ paddingBottom: 20, borderBottom: '1px solid rgba(92,78,51,0.15)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 400, letterSpacing: '0.4em', textTransform: 'uppercase', color: '#8a8778', marginBottom: 8 }}>
            Sales
          </div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 36, fontWeight: 300, color: '#1c2033', lineHeight: 1 }}>
            Customers
          </div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 300, color: '#8a8778', marginTop: 8 }}>
            Manage your customer database and track outstanding balances
          </div>
        </div>

        {viewMode === 'list' && (
          <button
            onClick={handleCreateCustomer}
            style={{
              fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 500,
              letterSpacing: '0.2em', textTransform: 'uppercase',
              background: 'linear-gradient(135deg, #d97706, #b45309)',
              color: '#1c2033', border: 'none', padding: '12px 24px',
              borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 32px rgba(217,119,6,0.25)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none'; }}
          >
            <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Customer
          </button>
        )}
      </div>

      {viewMode === 'list' && <CustomerStats />}

      <div>
        {viewMode === 'list' && (
          <CustomerList
            onSelectCustomer={(customer) => { console.log('Selected customer:', customer); }}
            onEditCustomer={handleEditCustomer}
          />
        )}
        {(viewMode === 'create' || viewMode === 'edit') && (
          <CustomerForm
            customer={selectedCustomer}
            onSuccess={handleFormSuccess}
            onCancel={handleFormCancel}
          />
        )}
      </div>
    </div>
  );
};